var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDashboardIcon = function SvgDashboardIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#6d788d",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_171)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 20.707C19.8947 20.5195 20 20.2651 20 19.9999V10.9999H21.7067C22.1637 10.9999 22.3812 10.4374 22.043 10.1299L12.673 1.61192C12.4889 1.4444 12.2489 1.35156 12 1.35156C11.7511 1.35156 11.5111 1.4444 11.327 1.61192L1.957 10.1299C1.61883 10.4374 1.83632 10.9999 2.29333 10.9999H4.00001V19.9999C4.00001 20.2651 4.10537 20.5195 4.29291 20.707C4.48044 20.8946 4.7348 20.9999 5.00001 20.9999H19C19.2652 20.9999 19.5196 20.8946 19.7071 20.707ZM10.5 14.9999C10.2239 14.9999 10 15.2238 10 15.4999V18.4999C10 18.7761 10.2239 18.9999 10.5 18.9999H13.5C13.7762 18.9999 14 18.7761 14 18.4999V15.4999C14 15.2238 13.7762 14.9999 13.5 14.9999H10.5Z",
    fill: "#758AB9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 4,
    height: 4,
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DashboardIcon.66437ec7.svg";
export { ForwardRef as ReactComponent };